import React from 'react';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';
import Directions from '../Directions/Directions';
import Scanner from '../Scanner';
import Modal from '../Modal/Modal';
import Pages from '../Pages/Pages';
import CodeInput from '../CodeInput';
import MessagePage from '../Phone/MessagePage';

export interface Props {
  selectedPoint?: string;
  setSelectedPoint: (code: string) => void;
}

const ModalRouter: React.FC<Props> = ({
  selectedPoint,
  setSelectedPoint,
}: Props) => {
  let { url } = useRouteMatch();
  let history = useHistory();

  return (
    <Switch>
      <Route path={`${url}/directions/:pointId`}>
        <Modal
          isOpen
          handleClose={() => {
            history.goBack();
          }}
        >
          <Directions />
        </Modal>
      </Route>
      <Route path={`${url}/trail-point/:pointId`}>
        <Modal
          isOpen
          handleClose={() => {
            history.goBack();
          }}
          type="fullScreen"
        >
          <Pages
            selectedPoint={selectedPoint}
            setSelectedPoint={setSelectedPoint}
            handleClose={() => {
              history.goBack();
            }}
          />
        </Modal>
      </Route>
      {/* Phone shell: one page of a message point (a photo reply, or the
          activity behind a card in the thread). */}
      <Route path={`${url}/message-page/:pointId/:pageIndex`}>
        {/* Wraps itself in the Modal. */}
        <MessagePage
          handleClose={() => {
            history.goBack();
          }}
        />
      </Route>
      <Route path={`${url}/menu`}>
        <Modal
          isOpen
          handleClose={() => {
            history.goBack();
          }}
        >
          Menu
        </Modal>
      </Route>
      <Route path={`${url}/scan`}>
        <Modal
          isOpen
          handleClose={() => {
            history.goBack();
          }}
        >
          <Scanner
            closeModal={() => {
              history.goBack();
            }}
          />
        </Modal>
      </Route>
      <Route path={`${url}/enter-code`}>
        <Modal
          isOpen
          handleClose={() => {
            history.goBack();
          }}
        >
          <CodeInput />
        </Modal>
      </Route>
    </Switch>
  );
};

export default ModalRouter;
